import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-hydrafacial1.jpg";
import heroImage1 from "../../../assets/images/ad-hydrafacial2.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  "ACNE": acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  "YOUTH": youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

const images = [
  {
    src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80",
    alt: "Before and After Hydrafacial Results",
  },
  {
    src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80",
    alt: "Hydrafacial Procedure Close-Up",
  },
  {
    src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80",
    alt: "Hydrafacial Equipment",
  },
];

// Functions from antiageing.jsx
function openModalWithNavigation(
  image,
  setModalImage,
  setIsModalOpen,
  setCurrentImageIndex,
  images
) {
  const index = images.findIndex((img) => img.src === image.src);
  setCurrentImageIndex(index);
  setModalImage(image);
  setIsModalOpen(true);
}

function closeModal(setIsModalOpen, setModalImage) {
  setIsModalOpen(false);
  setModalImage(null);
}

function navigatePrevious(
  e,
  currentImageIndex,
  images,
  setCurrentImageIndex,
  setModalImage
) {
  e.stopPropagation();
  const newIndex = (currentImageIndex - 1 + images.length) % images.length;
  setCurrentImageIndex(newIndex);
  setModalImage(images[newIndex]);
}

function navigateNext(
  e,
  currentImageIndex,
  images,
  setCurrentImageIndex,
  setModalImage
) {
  e.stopPropagation();
  const newIndex = (currentImageIndex + 1) % images.length;
  setCurrentImageIndex(newIndex);
  setModalImage(images[newIndex]);
}

function navigateGalleryPrev(visibleGalleryImages, setVisibleGalleryImages) {
  if (visibleGalleryImages[0] > 0) {
    const newVisibleImages = visibleGalleryImages.map((idx) => idx - 1);
    setVisibleGalleryImages(newVisibleImages);
  }
}

function navigateGalleryNext(
  visibleGalleryImages,
  setVisibleGalleryImages,
  images
) {
  if (
    visibleGalleryImages[visibleGalleryImages.length - 1] <
    images.length - 1
  ) {
    const newVisibleImages = visibleGalleryImages.map((idx) => idx + 1);
    setVisibleGalleryImages(newVisibleImages);
  }
}

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("ADVANCED HYDRAFACIAL");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Explore Our Treatments</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function AdvancedSkin() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);
  const [openFaqItem, setOpenFaqItem] = useState(null);

  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best HydraFacial Treatment in Chennai, Bangalore | Skin Rejuvenation Therapy Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Best HydraFacial treatment in Chennai, Bangalore. Advanced skin rejuvenation, deep cleansing, and hydration solutions. Professional dermatological services at H-Cura clinic locations across Chennai Tamil Nadu and Bangalore Karnataka including Tambaram, Valasaravakkam, Gerugambakkam, Jayanagar areas."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "hydrafacial treatment Chennai, hydrafacial Bangalore, hydrafacial clinic Tamil Nadu, dermatologist Karnataka, skin rejuvenation Chennai Bangalore, hydrafacial specialist Tamil Nadu Karnataka, best hydrafacial clinic Chennai Bangalore, hydrafacial near me, deep cleansing facial Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, skin hydration treatment Tamil Nadu Karnataka, pore cleansing Chennai Bangalore, anti aging hydrafacial specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced hydrafacial Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, glowing skin facial Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, hydrafacial with LED therapy Chennai Bangalore, hydrafacial with oxygen infusion Tamil Nadu Karnataka, hydrafacial with PRP Chennai Bangalore, hydrafacial with skin whitening serum Tamil Nadu Karnataka, hydrafacial resurfacing Tambaram Jayanagar, skin texture improvement Valasaravakkam Koramangala, hydrafacial for acne Gerugambakkam BTM Layout, hydrafacial for pigmentation Chennai Bangalore, non invasive hydrafacial Tamil Nadu Karnataka, professional hydrafacial care Chennai Bangalore, hydrafacial skin renewal Tamil Nadu Karnataka, hydrafacial for dull skin Chennai Bangalore, hydrafacial doctor Tamil Nadu Karnataka, hydrafacial treatment center Chennai Bangalore, dermatology Chennai Bangalore, hydrafacial skincare clinic Tamil Nadu Karnataka, hydrafacial consultation Chennai Bangalore, hydrafacial skin analysis Tamil Nadu Karnataka, hydrafacial prevention Chennai Bangalore, hydrafacial skin health Tamil Nadu Karnataka, dermatological hydrafacial treatment Chennai Bangalore, cosmetic hydrafacial dermatology Tamil Nadu Karnataka, medical hydrafacial skincare Chennai Bangalore, professional hydrafacial treatment Tamil Nadu Karnataka, hydrafacial skin wellness Chennai Bangalore, hydrafacial dermatology services Tamil Nadu Karnataka, hydrafacial treatment Tambaram Gandhi Road Jayanagar, hydrafacial clinic Valasaravakkam Krishnamachari Nagar Koramangala, hydrafacial dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, hydrafacial doctor Chromepet Pallavaram JP Nagar Banashankari, hydrafacial skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, hydrafacial treatment clinic Virugambakkam Kundrathur Lalbagh, hydrafacial rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced Hydrafacial and skin rejuvenation treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-hydrafacial-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        {
          "@type": "State",
          "name": "Tamil Nadu"
        },
        {
          "@type": "State",
          "name": "Karnataka"
        },
        {
          "@type": "State",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Chennai"
        },
        {
          "@type": "City",
          "name": "Bangalore"
        },
        {
          "@type": "City",
          "name": "Bengaluru"
        },
        {
          "@type": "City",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Puducherry"
        },
        // Chennai Areas
        {
          "@type": "City",
          "name": "Tambaram"
        },
        {
          "@type": "City",
          "name": "Valasaravakkam"
        },
        {
          "@type": "City",
          "name": "Gerugambakkam"
        },
        {
          "@type": "City",
          "name": "Chromepet"
        },
        {
          "@type": "City",
          "name": "Pallavaram"
        },
        {
          "@type": "City",
          "name": "Perungalathur"
        },
        {
          "@type": "City",
          "name": "Porur"
        },
        {
          "@type": "City",
          "name": "Alwarthirunagar"
        },
        {
          "@type": "City",
          "name": "Virugambakkam"
        },
        {
          "@type": "City",
          "name": "Kundrathur"
        },
        {
          "@type": "City",
          "name": "Mangadu"
        },
        {
          "@type": "City",
          "name": "Poonamallee"
        },
        // Bangalore Areas
        {
          "@type": "City",
          "name": "Jayanagar"
        },
        {
          "@type": "City",
          "name": "Koramangala"
        },
        {
          "@type": "City",
          "name": "BTM Layout"
        },
        {
          "@type": "City",
          "name": "JP Nagar"
        },
        {
          "@type": "City",
          "name": "Banashankari"
        },
        {
          "@type": "City",
          "name": "Basavanagudi"
        },
        {
          "@type": "City",
          "name": "Wilson Garden"
        },
        {
          "@type": "City",
          "name": "Lalbagh"
        }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Hydrafacial Treatment",
        "Skin Rejuvenation",
        "Deep Cleansing Facial",
        "Skin Hydration Therapy",
        "Pore Cleansing",
        "Anti-Aging Facial"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "HydraFacial Treatment Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced HydraFacial Treatment"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "HydraFacial with LED Light Therapy"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "HydraFacial with Oxygen Infusion"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "HydraFacial with PRP"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "HydraFacial with Skin Whitening Serum"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Deep Cleansing HydraFacial"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Anti-Aging HydraFacial"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent HydraFacial treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best HydraFacial skin rejuvenation treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing HydraFacial treatment results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best HydraFacial Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced HydraFacial treatment and skin rejuvenation solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for glowing, healthy skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-hydrafacial-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best HydraFacial Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced HydraFacial treatment and skin rejuvenation solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "HydraFacial Treatment, Skin Rejuvenation, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-hydrafacial-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-hydrafacial-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Advanced HydraFacial Treatment",
          "item": "https://www.h-cura.com/advanced-hydrafacial-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for HydraFacial treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides HydraFacial treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of HydraFacial treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced HydraFacial Treatment, HydraFacial with LED Light Therapy, HydraFacial with Oxygen Infusion, HydraFacial with PRP, HydraFacial with Skin Whitening Serum, Deep Cleansing HydraFacial, and Anti-Aging HydraFacial across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for HydraFacial treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        },
        {
          "@type": "Question",
          "name": "Is HydraFacial suitable for sensitive skin?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, HydraFacial is gentle and safe for sensitive skin. The treatment can be customized with mild serums and light suction levels to avoid irritation while still delivering visible results."
          }
        },
        {
          "@type": "Question",
          "name": "How often should I get HydraFacial treatments?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "For best results, it is recommended to undergo HydraFacial once every 4 weeks, especially if you have acne-prone or aging skin. Our specialists will suggest a personalized frequency based on your skin type and concerns."
          }
        },
        {
          "@type": "Question",
          "name": "What results can I expect after a HydraFacial?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can expect an immediate improvement in skin texture, hydration, and radiance. Regular sessions lead to reduced fine lines, fewer breakouts, and even skin tone. Results are visible from the first session itself."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-hydrafacial-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-hydrafacial-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  // Using antiageing.jsx functions with the necessary parameters
  const openModal = (image) => {
    openModalWithNavigation(
      image,
      setModalImage,
      setIsModalOpen,
      setCurrentImageIndex,
      images
    );
  };

  const handleCloseModal = () => {
    closeModal(setIsModalOpen, setModalImage);
  };

  const handleNavigatePrevious = (e) => {
    navigatePrevious(
      e,
      currentImageIndex,
      images,
      setCurrentImageIndex,
      setModalImage
    );
  };

  const handleNavigateNext = (e) => {
    navigateNext(
      e,
      currentImageIndex,
      images,
      setCurrentImageIndex,
      setModalImage
    );
  };

  const handleNavigateGalleryPrev = () => {
    navigateGalleryPrev(visibleGalleryImages, setVisibleGalleryImages);
  };

  const handleNavigateGalleryNext = () => {
    navigateGalleryNext(visibleGalleryImages, setVisibleGalleryImages, images);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;

      if (e.key === "ArrowLeft") {
        handleNavigatePrevious(e);
      } else if (e.key === "ArrowRight") {
        handleNavigateNext(e);
      } else if (e.key === "Escape") {
        handleCloseModal();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen, currentImageIndex]);
  
  const toggleFaq = (id) => {
    setOpenFaqItem(openFaqItem === id ? null : id);
  };

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
     <section
  className="ads-hero"
  style={{
    backgroundImage: `linear-gradient(rgba(128, 126, 126, 0.5), rgba(23, 23, 23, 0.5)), 
    url(${heroImage})`,
    
  }}
>

        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Revolutionary Hydrafacial Therapy for Skin Rejuvenation
          </h1>
          <p className="ads-hero-text">
            Experience the ultimate skin treatment that cleanses, exfoliates,
            and hydrates for a radiant complexion.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with HydraFacial Treatment</h2>
                        <p className="ads-nav-description">
              Our HydraFacial treatment combines advanced technology with
              nourishing ingredients for optimal skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>ADVANCED HYDRAFACIAL</strong>
                <p>Thoroughly cleanses and purifies your skin.</p>
                <ul className="ads-treatment-details">
                  <li>Improves Skin Texture and Tone</li>
                  <li>Reduces Fine Lines and Wrinkles</li>
                  <li>Minimized pores and make glowing skin</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>HYDRAFACIAL WITH LED LIGHT THERAPY</strong>
                <p>Effective for acne control and cellular turnover.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Inflammation</li>
                  <li>Promotes Healing</li>
                  <li>Enhances Skin Rejuvenation</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>HYDRAFACIAL WITH OXYGEN INFUSION</strong>
                <p>Infuses oxygen and vitamins for a radiant look.</p>
                <ul className="ads-treatment-details">
                  <li>Revitalizes Dull Skin</li>
                  <li>Boosts Skin Radiance</li>
                  <li>Deeply Hydrates</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>HYDRAFACIAL WITH PRP</strong>
                <p>Perfect for anti-aging and collagen production.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Deep Wrinkles</li>
                  <li>Stimulates Collagen</li>
                  <li>Improves Skin Firmness</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>HYDRAFACIAL WITH SKIN WHITENING SERUM</strong>
                <p>For treating pigmentation and uneven skin tone.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Sun Damage</li>
                  <li>Evens Skin Tone</li>
                  <li>Brightens Complexion</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our HydraFacial treatments are customized for each individual's
              skin type and concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of HydraFacial
              treatment.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3> Advanced HydraFacial Treatment </h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="HydraFacial Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector(
                        ".ads-treatment-gallery"
                      );
                      if (gallery) {
                        gallery.scrollBy({
                          left: -gallery.clientWidth * 0.8,
                          behavior: "smooth",
                        });
                      }
                      handleNavigateGalleryPrev();
                    }}
                    style={{
                      display: visibleGalleryImages[0] > 0 ? "block" : "none",
                    }}
                    aria-label="Previous image"
                  >
                    &#10094;
                  </button>
                  <button
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector(
                        ".ads-treatment-gallery"
                      );
                      if (gallery) {
                        gallery.scrollBy({
                          left: gallery.clientWidth * 0.8,
                          behavior: "smooth",
                        });
                      }
                      handleNavigateGalleryNext();
                    }}
                    style={{
                      display:
                        visibleGalleryImages[visibleGalleryImages.length - 1] <
                        images.length - 1
                          ? "block"
                          : "none",
                    }}
                    aria-label="Next image"
                  >
                    &#10095;
                  </button>
                </div>

                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span
                      key={index}
                      className={`ads-gallery-dot ${
                        visibleGalleryImages.includes(index) ? "active" : ""
                      }`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h3 className="ads-hero-title">
                  ✨ Advanced HydraFacial Treatment in Bangalore & Chennai – For Glowing, Flawless Skin
                </h3>
                <p className="ads-hero-text">
                  Discover the power of HydraFacial treatment in Bangalore and Chennai at H-Cura – your trusted destination for non-invasive and highly effective facial rejuvenation solutions. Our dermatologist-approved skin therapy is designed to deliver instant glow, reduce dullness, and deeply cleanse your skin using medical-grade HydraFacial machines.
                </p>

                <h4>Empowering Skin Rejuvenation with HydraFacial</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                      INNOVATIVE HYDRAFACIAL
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough HydraFacial technology combines cleansing,
                    exfoliation, and hydration for a complete skin treatment.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of HydraFacial</h5>
                  <p>HydraFacial provides the following benefits:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Deep Cleansing" />
                      </span>{" "}
                      <strong>Deep Cleansing</strong>
                      <p>
                        Thoroughly removes impurities and pollutants, leaving
                        skin refreshed.
                      </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Enhanced Hydration"
                        />
                      </span>{" "}
                      <strong>Enhanced Hydration</strong>
                      <p>
                        Infuses skin with hydrating serums for maximum moisture
                        retention.
                      </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Promotes Skin Renewal"
                        />
                      </span>{" "}
                      <strong>Promotes Skin Renewal</strong>
                      <p>
                        Stimulates cell turnover for a healthier, more youthful
                        appearance.
                      </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Non-Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Non-Invasive Treatment</strong>
                      <p>
                        Gentle on the skin while providing significant results
                        without downtime.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>45 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Immediate Results</p>
                    <span className="ads-subtitle">Quick Recovery</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-unique-features-section" style={{ padding: "60px 20px", background: "#f8f9ff" }}>
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Our Specialty</span>
          <h2>What Makes Our HydraFacial Unique?</h2>
          <p className="ads-section-subtitle">
            At H-Cura, our HydraFacial specialists follow an advanced protocol designed to:
          </p>
        </div>
        <div style={{ maxWidth: "800px", margin: "0 auto", textAlign: "left", padding: "20px" }}>
          <p style={{ marginBottom: "15px", fontSize: "16px", lineHeight: "1.6" }}>🔹 Detoxify and cleanse your pores with vortex technology</p>
          <p style={{ marginBottom: "15px", fontSize: "16px", lineHeight: "1.6" }}>🔹 Exfoliate dead skin cells gently</p>
          <p style={{ marginBottom: "15px", fontSize: "16px", lineHeight: "1.6" }}>🔹 Infuse antioxidants, peptides, and hyaluronic acid</p>
          <p style={{ marginBottom: "15px", fontSize: "16px", lineHeight: "1.6" }}>🔹 Improve skin hydration, brightness, and firmness</p>
          <p style={{ marginBottom: "15px", fontSize: "16px", lineHeight: "1.6" }}>🔹 Minimize enlarged pores and reduce signs of aging</p>
        </div>

        <div className="ads-benefits-header" style={{ marginTop: "50px" }}>
          <span className="ads-section-tag">Elevate Your Experience</span>
          <h2>Popular Add-On Treatments Alongside HydraFacial</h2>
          <p className="ads-section-subtitle">
            Boost your skin glow with our combined HydraFacial packages, including:
          </p>
        </div>
        <div style={{ maxWidth: "800px", margin: "0 auto", textAlign: "left", padding: "20px" }}>
          <div style={{ marginBottom: "25px" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>🔹 HydraFacial + LED Light Therapy</h3>
            <p style={{ fontSize: "16px", lineHeight: "1.6" }}>Effective for acne control, reducing inflammation, and improving cellular turnover.</p>
          </div>
          <div style={{ marginBottom: "25px" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>🔹 HydraFacial + Oxygen Infusion</h3>
            <p style={{ fontSize: "16px", lineHeight: "1.6" }}>Ideal for dull and tired skin. Infuses oxygen and vitamins for a radiant look.</p>
          </div>
          <div style={{ marginBottom: "25px" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>🔹 HydraFacial + PRP</h3>
            <p style={{ fontSize: "16px", lineHeight: "1.6" }}>Perfect for anti-aging, collagen production, and reducing deep wrinkles and fine lines.</p>
          </div>
          <div style={{ marginBottom: "25px" }}>
            <h3 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "10px" }}>🔹 HydraFacial + Skin Whitening Serum</h3>
            <p style={{ fontSize: "16px", lineHeight: "1.6" }}>For treating pigmentation, sun damage, and uneven skin tone.</p>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced treatments combine cutting-edge science with
            personalized care to restore your skin's health and confidence.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in HydraFacial technology to deliver natural skin rejuvenation results.",
              features: [
                "Innovative Treatment Protocols",
                "FDA-Approved Procedures",
                "Clinically Proven Results",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists are experts in skin treatments and are dedicated to your care.",
              features: [
                "Highly Trained Professionals",
                "Years of Experience",
                "Personalized Attention",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every HydraFacial treatment plan is tailored to your skin type and concerns.",
              features: [
                "Individualized Sessions",
                "Continuous Progress Tracking",
                "Optimized Treatment Frequency",
              ],
            },
            {
              icon: "✨",
              title: "Natural-Looking Results",
              desc: "Achieve smoother, healthier skin that looks completely natural with our HydraFacial solutions.",
              features: [
                "Subtle Enhancements",
                "Long-Lasting Benefits",
                "Effortless Aesthetics",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "Our treatments meet the highest medical standards, ensuring a safe and sterile environment at all times.",
              features: [
                "Medical-Grade Facilities",
                "Strict Safety Protocols",
                "Patient-Centric Care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of clients who have experienced astonishing results with HydraFacial.",
              features: [
                "Over 5000 Happy Clients",
                "Remarkable Clinical Outcomes",
                "Consistently High Success Rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Radiant Skin with HydraFacial</h2>
          <p className="ads-process-subtitle">
            Embrace our comprehensive 4-step approach for sustainable skin
            rejuvenation.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your skin health and treatment goals.",
              details: [
                "Detailed skin analysis",
                "Personal health review",
                "Customized treatment roadmap",
                "Expectation setting",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our team collaborates with you to design a bespoke HydraFacial treatment plan that best suits your skin needs.",
              details: [
                "Personalized regimen design",
                "Session scheduling",
                "Lifestyle coaching",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert HydraFacial Session",
              desc: "Experience our precise techniques as we apply HydraFacial for optimal skin rejuvenation.",
              details: [
                "Sterile preparation",
                "Precision HydraFacial application",
                "Targeted skin treatment",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care, ensuring your progress is monitored and optimized.",
              details: [
                "Routine progress reviews",
                "Adaptive treatment refinement",
                "Maintenance plans",
                "Long-term support",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>
     <section className="ads-faq-section" style={{ padding: "60px 20px", background: "#f8f9fa" }}>
  <div className="ads-benefits-header">
    <span className="ads-section-tag">Knowledge Center</span>
    <h2>Frequently Asked Questions – Advanced HydraFacial Treatment</h2>
    <p className="ads-section-subtitle">
      Find answers to commonly asked questions about our HydraFacial treatments
    </p>
  </div>
  
  <div style={{ maxWidth: "900px", margin: "0 auto", padding: "20px" }}>
    {[
      {
        id: "faq-1",
        question: "1. What is HydraFacial treatment and how does it work?",
        answer: "HydraFacial is a non-invasive skin treatment that combines cleansing, exfoliation, extraction, hydration, and antioxidant protection. It works using a vortex-fusion technology that deeply cleanses and nourishes the skin. This treatment is suitable for all skin types and provides immediate glow and hydration."
      },
      {
        id: "faq-2",
        question: "2. What skin concerns does HydraFacial treat?",
        answer: "HydraFacial effectively treats a variety of skin issues including acne, blackheads, enlarged pores, hyperpigmentation, dullness, dryness, fine lines, and uneven skin tone."
      },
      {
        id: "faq-3",
        question: "3. Is HydraFacial suitable for sensitive skin?",
        answer: "Yes, HydraFacial is gentle and safe for sensitive skin. The treatment can be customized with mild serums and light suction levels to avoid irritation while still delivering visible results."
      },
      {
        id: "faq-4",
        question: "4. How long does a HydraFacial session take?",
        answer: "A standard HydraFacial session typically lasts 30 to 45 minutes. There is no downtime, so you can return to your routine immediately after the session."
      },
      {
        id: "faq-5",
        question: "5. How often should I get HydraFacial treatments?",
        answer: "For best results, it is recommended to undergo HydraFacial once every 4 weeks, especially if you have acne-prone or aging skin. Our specialists will suggest a personalized frequency based on your skin type and concerns."
      },
      {
        id: "faq-6",
        question: "6. What is the cost of HydraFacial in Bangalore or Chennai?",
        answer: "At H-Cura Clinics in Jayanagar (Bangalore) and various locations in Chennai including Tambaram, Valasaravakkam, and Gerugambakkam, the cost of HydraFacial treatment is affordable and depends on the type of facial, add-ons (like PRP, LED therapy), and number of sessions. We offer custom packages after consultation."
      },
      {
        id: "faq-7",
        question: "7. What results can I expect after a HydraFacial?",
        answer: "You can expect an immediate improvement in skin texture, hydration, and radiance. Regular sessions lead to reduced fine lines, fewer breakouts, and even skin tone. Results are visible from the first session itself."
      },
      {
        id: "faq-8",
        question: "8. Can men get HydraFacial treatments?",
        answer: "Absolutely. HydraFacial is highly effective for men with oily skin, open pores, or acne issues. It helps in deep pore cleansing and gives the skin a refreshed appearance."
      },
      {
        id: "faq-9",
        question: "9. Are there any side effects or risks with HydraFacial?",
        answer: "HydraFacial is a safe and FDA-approved treatment with minimal risk. Some people may experience slight redness immediately after, which subsides quickly. Our trained professionals ensure the safest application for your skin."
      },
      {
        id: "faq-10",
        question: "10. Where can I get the best HydraFacial in Bangalore or Chennai?",
        answer: "You can get the best HydraFacial treatment at H-Cura Multispeciality Clinics in Bangalore (Jayanagar) and Chennai (Tambaram, Valasaravakkam, Gerugambakkam). We use medical-grade technology, certified skin specialists, and customized treatment plans to ensure excellent results."
      }
    ].map((faq) => (
      <div 
        key={faq.id}
        style={{ 
          border: "1px solid #e0e0e0", 
          borderRadius: "8px", 
          overflow: "hidden",
          marginBottom: "15px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
        }}
      >
        <div 
          onClick={() => toggleFaq(faq.id)}
          style={{ 
            padding: "15px 20px", 
            backgroundColor: "#ffffff", 
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <h3 style={{ 
            fontSize: "17px", 
            fontWeight: "600", 
            color: "#2C3E50", 
            margin: 0 
          }}>
            {faq.question}
          </h3>
          <span style={{ 
            fontSize: "22px", 
            fontWeight: "bold", 
            color: "#3498DB" 
          }}>
            {openFaqItem === faq.id ? '−' : '+'}
          </span>
        </div>
        {openFaqItem === faq.id && (
          <div style={{ 
            padding: "0 20px 15px", 
            backgroundColor: "#ffffff",
            borderTop: "1px solid #f0f0f0",
            animation: "fadeIn 0.3s ease"
          }}>
            <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#555" }}>
              {faq.answer}
            </p>
          </div>
        )}
      </div>
    ))}
  </div>
</section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best HydraFacial Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>HydraFacial Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced HydraFacial treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur areas with Advanced HydraFacial Treatment, HydraFacial with LED Light Therapy, Deep Cleansing HydraFacial, Anti-Aging HydraFacial. 
          Specializing in HydraFacial & Skin Rejuvenation. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best hydrafacial treatment Tamil Nadu, hydrafacial specialist Chennai, hydrafacial dermatologist Tambaram, hydrafacial clinic Chromepet, hydrafacial treatment Pallavaram, deep cleansing facial Perungalathur.
        </p>
        
        <h3>HydraFacial Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional HydraFacial services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam communities with HydraFacial with Oxygen Infusion, HydraFacial with PRP, HydraFacial with Skin Whitening Serum, Skin Hydration Therapy. 
          Specializing in HydraFacial Treatments & Skin Renewal. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Hydrafacial treatment Valasaravakkam, hydrafacial clinic Porur, hydrafacial dermatologist Alwarthirunagar, hydrafacial specialist Virugambakkam, hydrafacial skin rejuvenation Chennai Tamil Nadu.
        </p>
        
        <h3>Complete HydraFacial Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive HydraFacial treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee residents with Non-Invasive HydraFacial, Pore Cleansing Treatment, Anti-Aging HydraFacial, Professional HydraFacial Care. 
          Offering Complete HydraFacial Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Hydrafacial treatment Gerugambakkam, hydrafacial clinic Kundrathur, hydrafacial dermatologist Mangadu, hydrafacial specialist Poonamallee, hydrafacial skin rejuvenation Chennai Tamil Nadu.
        </p>

        <h3>Advanced HydraFacial Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier HydraFacial and skin rejuvenation services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh areas with Advanced HydraFacial Treatment, HydraFacial with LED Light Therapy, HydraFacial with PRP, Anti-Aging HydraFacial. 
          Specializing in Advanced HydraFacial & Dermatology Treatments. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best hydrafacial treatment Bangalore, hydrafacial specialist Karnataka, hydrafacial dermatologist Jayanagar, hydrafacial clinic Koramangala, hydrafacial treatment BTM Layout, deep cleansing facial JP Nagar, 
          hydrafacial doctor Banashankari, hydrafacial skin rejuvenation Basavanagudi, hydrafacial dermatology Wilson Garden, hydrafacial treatment Lalbagh, hydrafacial clinic Bangalore Karnataka, hydrafacial specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides HydraFacial treatment and skin rejuvenation services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Hydrafacial treatment Bangalore, skin rejuvenation Karnataka, hydrafacial dermatologist Bengaluru, hydrafacial clinic Bangalore, hydrafacial specialist Karnataka, deep cleansing facial Bangalore, 
          skin hydration therapy Karnataka, pore cleansing Bangalore, anti aging hydrafacial Karnataka, glowing skin facial Bangalore, hydrafacial with LED therapy Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides HydraFacial treatment and skin rejuvenation services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Hydrafacial treatment Chennai, skin rejuvenation Tamil Nadu, hydrafacial dermatologist Chennai, hydrafacial clinic Tamil Nadu, hydrafacial specialist Chennai, deep cleansing facial Tamil Nadu.
        </p>

        <h3>Advanced HydraFacial Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive HydraFacial treatment including Advanced HydraFacial Treatment, HydraFacial with LED Light Therapy, HydraFacial with Oxygen Infusion, 
          HydraFacial with PRP, HydraFacial with Skin Whitening Serum, Deep Cleansing HydraFacial, Anti-Aging HydraFacial, 
          Non-Invasive HydraFacial, and Pore Cleansing Treatment.
          Best hydrafacial treatment Chennai Bangalore, hydrafacial specialist Tamil Nadu Karnataka, hydrafacial dermatologist Chennai Bangalore, hydrafacial clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert HydraFacial Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified HydraFacial dermatologists and HydraFacial specialists providing personalized HydraFacial treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Hydrafacial specialist Chennai Bangalore, hydrafacial dermatologist Tamil Nadu Karnataka, hydrafacial doctor Chennai Bangalore, hydrafacial treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          hydrafacial treatment near me, skin rejuvenation near me, dermatologist near me, hydrafacial clinic near me, deep cleansing facial near me, best hydrafacial treatment, 
          professional hydrafacial, hydrafacial doctor, hydrafacial skin clinic, hydrafacial dermatology clinic, hydrafacial with LED therapy, hydrafacial with oxygen infusion, hydrafacial with PRP, 
          hydrafacial with skin whitening serum, pore cleansing treatment, anti aging hydrafacial, glowing skin facial, non invasive hydrafacial, skin hydration therapy, 
          cosmetic hydrafacial dermatology, medical hydrafacial skincare, hydrafacial skin health, hydrafacial consultation, hydrafacial skin analysis, hydrafacial treatment prevention, dermatological hydrafacial treatment, 
          hydrafacial skin wellness, hydrafacial therapy, hydrafacial skin problem solutions, hydrafacial for acne, hydrafacial for pigmentation, 
          hydrafacial specialist doctor, professional hydrafacial care, advanced hydrafacial treatment, innovative hydrafacial solutions, hydrafacial skin transformation, 
          youthful hydrafacial treatment, radiant hydrafacial therapy, hydrafacial skin renewal, hydrafacial management, hydrafacial for dull skin, 
          non-invasive hydrafacial treatment, safe hydrafacial treatment, effective hydrafacial care, proven hydrafacial solutions, personalized hydrafacial treatment, 
          customized hydrafacial therapy, expert hydrafacial care, quality hydrafacial dermatology services, trusted hydrafacial clinic, reliable hydrafacial treatment, 
          affordable hydrafacial care, convenient hydrafacial dermatology, accessible hydrafacial treatment, comprehensive hydrafacial solutions.
        </p>
      </div>

       {isModalOpen && (
        <div className="ads-modal-overlay" onClick={handleCloseModal}>
          <div
            className="ads-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="ads-close-modal" onClick={handleCloseModal}>
              &times;
            </button>
            <button
              className="ads-modal-nav ads-modal-prev"
              onClick={handleNavigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button
              className="ads-modal-nav ads-modal-next"
              onClick={handleNavigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdvancedSkin;
